export default "__VITE_ASSET__CzXu22Cw__"